import { gql } from '@apollo/client';

/** 用于角色抽屉中权限包多选下拉的数据源 */
export const QUERY_PERMISSION_PACKAGES_FOR_SELECT = gql`
  query QueryPermissionPackagesForSelect {
    listAllPermissionPackages {
      id
      name
    }
  }
`;

export interface PermissionPackageOption {
  id: number | string;
  name: string;
}

export interface QueryPermissionPackagesForSelectResponse {
  listAllPermissionPackages: PermissionPackageOption[];
}
